import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import HttpApi from "i18next-http-backend"

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: document.querySelector("html").attributes.lang.value,
    fallbackLng: "nl",
    defaultNS: "app",
    ns: ["app", "errors", "default"],
    debug: true,
    load: "currentOnly",
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: false, //   <---- this will do the magic
    },
    backend: {
      loadPath: "/i18n/{{lng}}/{{ns}}.json?c=" + process.env.GIT_SHA,
    },
  })

export default i18n
